__turbopack_context__.v({
  "widget": "f4uFeG_widget",
  "wrapper": "f4uFeG_wrapper",
});
